module.exports = __webpack_public_path__ + "img/Test_captcha.ae325dfb.png";